/** Niet-blokkerende banner: e-mailadres bevestigen (wachtwoordaccounts). */
import { Alert, Button, Stack } from '@mui/material';
import { useT } from '@/i18n/useT';
import { useEmailVerificationBanner } from '@/features/auth/hooks/useEmailVerificationBanner';

const EmailVerificationBanner = () => {
  const t = useT();
  const { visible, onDismiss, onResend, resendDisabled, errorMessage } =
    useEmailVerificationBanner();

  if (!visible) {
    return null;
  }

  return (
    <Alert
      data-testid="email-verification-banner"
      role="status"
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={onDismiss}
          aria-label={t('auth.emailVerification.dismiss', 'Sluiten')}
        >
          {t('auth.emailVerification.dismiss', 'Sluiten')}
        </Button>
      }
    >
      <Stack spacing={1}>
        <span>{t('auth.emailVerification.message', 'Bevestig je e-mailadres')}</span>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Button
            variant="outlined"
            color="inherit"
            size="small"
            disabled={resendDisabled}
            onClick={onResend}
          >
            {t('auth.emailVerification.resend', 'Mail opnieuw sturen')}
          </Button>
          {errorMessage ? <span role="alert">{errorMessage}</span> : null}
        </Stack>
      </Stack>
    </Alert>
  );
};

export default EmailVerificationBanner;
